(() => {
  'use strict';
  if (window.GGPixCart) return;
  const source = 'ggpix-personalizer';
  const cartUI = () => document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  const routeRoot = () => window.Shopify?.routes?.root || '/';
  let noticeTimer = null, noticeClose = null;
  function showCartSuccess(item, options) {
    const notice = document.querySelector('[data-ggpix-cart-success]');
    if (!notice || typeof item?.key !== 'string' || !item.key || !(Number(item.quantity) > 0)) return;
    clearTimeout(noticeTimer);
    noticeClose?.();
    const originalParent = notice.parentElement;
    const close = () => {
      clearTimeout(noticeTimer);
      try { if (notice.matches(':popover-open')) notice.hidePopover(); } catch {}
      notice.hidden = true;
      if (originalParent && notice.parentElement !== originalParent) originalParent.append(notice);
    };
    const resume = () => {
      clearTimeout(noticeTimer);
      noticeTimer = setTimeout(() => {
        if (notice.contains(document.activeElement) || notice.matches(':hover')) return;
        close();
      }, 8000);
    };
    const dismiss = () => {
      const focused = notice.contains(document.activeElement);
      close();
      if (focused && options.trigger instanceof HTMLElement && !options.trigger.disabled) options.trigger.focus({ preventScroll: true });
    };
    notice.querySelector('[data-cart-success-close]').onclick = dismiss;
    notice.onkeydown = event => { if (event.key === 'Escape') { event.stopPropagation(); dismiss(); } };
    notice.onmouseenter = notice.onfocusin = () => clearTimeout(noticeTimer);
    notice.onmouseleave = notice.onfocusout = resume;
    notice.hidden = false;
    let topLayer = false;
    try { if (typeof notice.showPopover === 'function') { notice.showPopover(); topLayer = true; } } catch {}
    if (!topLayer) document.querySelector('dialog[open]')?.append(notice);
    const title = notice.querySelector('[data-cart-success-title]');
    title.textContent = title.textContent;
    noticeClose = close;
    resume();
  }
  const sectionSpecs = (ui, item) => {
    if (ui && item?.key) ui.cartItemKey = item.key;
    const specs = ui?.getSectionsToRender?.() || [{ id: 'cart-icon-bubble' }];
    return specs.filter(section => section && typeof section.id === 'string').slice(0, 5);
  };
  const parsedSection = (html, selector = '.shopify-section') => {
    if (typeof html !== 'string' || !html.trim()) return null;
    try { return new DOMParser().parseFromString(html, 'text/html').querySelector(selector); }
    catch { return null; }
  };
  async function readJSON(url) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 12000);
    try {
      const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: controller.signal });
      if (!response.ok) throw new Error('cart_refresh_failed');
      return await response.json();
    } finally { clearTimeout(timer); }
  }
  function prepareAdd(data, options = {}) {
    // Checkout renders property keys verbatim, outside the theme translations.
    if (document.documentElement.lang.toLowerCase().startsWith('hu')) {
      const labels = { 'Previzualizare GG Pix': 'Élő előnézet', 'Design GG Pix': 'GG Pix terv', 'Format GG Pix': 'Méret és kivitel', 'Pagini / Oldalak': 'Oldalak', 'Limba / Nyelv': 'Nyelv' };
      for (const [source, target] of Object.entries(labels)) {
        const key = `properties[${source}]`, value = data.get(key);
        if (value === null) continue;
        if (typeof value === 'string') data.set(`properties[${target}]`, value);
        else data.set(`properties[${target}]`, value, value.name);
        data.delete(key);
      }
    }
    const application = document.querySelector('[data-ggpix-artwork]') ? 'artwork' : document.querySelector('[data-ggpix-collage]') ? 'collage' : document.querySelector('[data-ggpix-editor]') ? 'personalizer' : '';
    window.GGPixCartRepair?.prepare(data, application);
    const ui = cartUI();
    data.set('sections', sectionSpecs(ui).map(section => section.id).join(','));
    data.set('sections_url', location.pathname);
    const trigger = options.trigger || document.activeElement;
    if (trigger instanceof HTMLElement) ui?.setActiveElement?.(trigger);
    return data;
  }
  function renderBubble(sections) {
    const target = document.getElementById('cart-icon-bubble');
    const replacement = parsedSection(sections['cart-icon-bubble']);
    if (!target || !replacement) return false;
    target.innerHTML = replacement.innerHTML;
    return true;
  }
  function sync(cart){
    if(!Number.isSafeInteger(cart?.item_count)||cart.item_count<0)return false;
    const count=cart.item_count;document.querySelectorAll('[data-gg-cart-count]').forEach(node=>{node.textContent=String(count);node.hidden=false;const link=node.closest('a');if(link){const label=link.dataset.cartLabel||link.getAttribute('aria-label')||'Cart';link.dataset.cartLabel=label;link.setAttribute('aria-label',label+' ('+count+')');}});
    const target=document.getElementById('cart-icon-bubble');if(!target)return true;let bubble=target.querySelector('.cart-count-bubble');
    if(!count){bubble?.remove();return true;}if(!bubble){bubble=document.createElement('div');bubble.className='cart-count-bubble';target.append(bubble);}
    bubble.replaceChildren();const value=document.createElement('span');value.setAttribute('aria-hidden','true');value.textContent=String(count);const accessible=document.createElement('span');accessible.className='visually-hidden';accessible.textContent=String(count);bubble.append(value,accessible);return true;
  }
  let refreshing=null;
  async function refreshBubbleFallback(){if(!refreshing)refreshing=readJSON(`${routeRoot()}cart.js`).then(sync).finally(()=>refreshing=null);return refreshing;}
  const receive=event=>{const data=event?.detail?.cart||event?.detail?.cartData||event?.cartData;if(!sync(data))refreshBubbleFallback().catch(()=>{});};
  for(const name of ['cart:updated','cart:refresh','ggpix:cart-updated'])document.addEventListener(name,receive);
  window.addEventListener('cart:updated',receive);
  if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined')subscribe(PUB_SUB_EVENTS.cartUpdate,receive);
  async function afterAdd(item, options = {}) {
    const ui = cartUI();
    const specs = sectionSpecs(ui, item);
    if (item?.properties?._ggpix_design_id && window.GGPixCheckoutData) {
      try { item = await window.GGPixCheckoutData.sealItem(item, { sections: specs.map(section => section.id) }); }
      catch { if (window.GGPixCartRepair?.active) window.GGPixCartRepair.failed(); document.dispatchEvent(new CustomEvent('ggpix:cart-refresh-failed', { detail: { key: item.key } })); return false; }
      if (ui && item?.key) ui.cartItemKey = item.key;
    }
    if (window.GGPixCartRepair?.active) return window.GGPixCartRepair.finish(item);
    try { showCartSuccess(item, options); } catch {}
    let sections = { ...(item?.sections || {}) };
    const valid = () => specs.every(section => parsedSection(sections[section.id], section.selector));
    try {
      if (!valid()) {
        const url = new URL(`${routeRoot()}cart`, location.origin);
        url.searchParams.set('sections', specs.map(section => section.id).join(','));
        sections = { ...sections, ...(await readJSON(url.href)) };
      }
      renderBubble(sections);
      if(document.querySelector('[data-gg-cart-count]'))await refreshBubbleFallback();
      const payload = { ...item, sections };
      if (ui && valid()) {
        const trigger = options.trigger || document.querySelector('[data-ggpix-editor] [data-action="review"]');
        if (trigger instanceof HTMLElement) ui.setActiveElement?.(trigger);
        ui.classList.remove('is-empty');
        ui.renderContents(payload);
      } else if (!renderBubble(sections)) {
        await refreshBubbleFallback();
      }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        Promise.resolve(publish(PUB_SUB_EVENTS.cartUpdate, {
          source, productVariantId: item.variant_id || item.id, cartData: payload
        })).catch(() => {});
      }
      document.dispatchEvent(new CustomEvent('ggpix:cart-updated', { detail: { key: item.key, variantId: item.variant_id || item.id } }));
      return true;
    } catch {
      try { await refreshBubbleFallback(); } catch {}
      document.dispatchEvent(new CustomEvent('ggpix:cart-refresh-failed', { detail: { key: item?.key } }));
      return false;
    }
  }
  window.GGPixCart = Object.freeze({ prepareAdd, afterAdd, sync, refresh:refreshBubbleFallback });
})();

